import { InfoScreenNavigationProps } from "./types"
import React from "react"
import Info from "./info-screen"
import { PageRoot } from "~screens/page-root"


const InfoScreen: React.FC<InfoScreenNavigationProps> = ({ route }) => {
  return (
    <PageRoot>
      <Info userId={route.params.userId} />
    </PageRoot>
  )
}

export default InfoScreen
